import React from 'react';

const MongoDB_QueryAPI = () => {
  return (
    <div>
      <h1>MongoDB_QueryAPI Component</h1>
      <p>This is the MongoDB_QueryAPI page.</p>
    </div>
  );
};

export default MongoDB_QueryAPI;
